<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Transactions"
            bc1="App"
            bc2="Gateway"
            bc3="Details"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
              type="button"
              class="btn btn-gradient-danger btn-sm"
              @click="$emit('backFromDetailPage')"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section v-if="transactionDetails" class="invoice-preview-wrapper">
          <div class="row invoice-preview">
            <!-- Invoice -->
            <div class="col-12">
              <div class="card invoice-preview-card">
                <div class="card-body invoice-padding pb-0">
                  <!-- Header starts -->
                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                    <div>
                      <div class="logo-wrapper">
                        <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                      </div>
                      <p class="card-text mb-25">Gateway Ref Id:
                        {{ transactionDetails.gateway_reference_id ? transactionDetails.gateway_reference_id : 'N/A' }}
                      </p>

                      <p class="card-text mb-0">Amount: <span
                        class="text-warning">{{
                          parseFloat(transactionDetails.amount / 100).toFixed(amountDecimalPlaces)
                        }}</span></p>

<!--                      <p class="card-text mb-0">Payment Method:-->
<!--                                                <span class="badge-sm badge badge-light-info">{{ transactionDetails.payment_method.name }}</span>-->
<!--                      </p>-->


                    </div>
                    <div class="mt-md-0 mt-2">
                      <h4 class="invoice-title">
                        Transaction
                        <span class="invoice-number">#{{ transactionDetails.uuid }}</span>
                      </h4>
                      <!--                      <div class="invoice-date-wrapper justify-content-end">-->
                      <!--                        <p class="invoice-date-title">Date Created:</p>-->
                      <!--                        <p class="invoice-date">{{-->
                      <!--                            new Date(transactionDetails.created_at)-->
                      <!--                                .toISOString()-->
                      <!--                                .slice(0, 16)-->
                      <!--                                .replace("T", " ")-->
                      <!--                          }}</p>-->
                      <!--                      </div>-->
                    </div>
                  </div>
                  <!-- Header ends -->
                </div>

                <hr class="invoice-spacing"/>

                <div class="table-responsive" v-if="gatewayDetails">
                  <table class="table">
                    <thead>
                    <tr>
                      <th class="py-1"></th>
                      <th class="py-1">S.No</th>
                      <th class="py-1">Status</th>
                      <th class="py-1">Endpoint</th>
                      <th class="py-1">REQUEST TIME</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--                    <tr>-->
                    <!--                      <td class="d-flex">-->
                    <!--                        <button type="button" class="btn btn-sm  btn-primary waves-effect waves-float waves-light"-->
                    <!--                                data-toggle="collapse" data-target="#demoa1"-->
                    <!--                                @click="accordionToShow  = 'a1';showRequest = true">-->
                    <!--                          Request-->
                    <!--                        </button>-->
                    <!--                        <button type="button" class="btn btn-sm ml-1 btn-warning waves-effect waves-float waves-light"-->
                    <!--                                data-toggle="collapse" data-target="#demoaba1"-->
                    <!--                                @click="accordionToShow  = 'a1';showRequest = false">-->
                    <!--                          Response-->
                    <!--                        </button>-->
                    <!--                      </td>-->
                    <!--                      <td class="py-1">-->
                    <!--                        <span class="badge badge-light-danger badge-sm" v-if="gatewayDetails.status == 0">Failure</span>-->
                    <!--                        <span class="badge badge-light-success badge-sm"-->
                    <!--                              v-else-if="gatewayDetails.status == 1">Success</span>-->
                    <!--                        <span class="badge badge-light-warning badge-sm" v-else-if="gatewayDetails.status == 2">Pending From Gateway</span>-->
                    <!--                        <span class="badge badge-light-info badge-sm" v-else>Gateway Response Received</span>-->
                    <!--                      </td>-->
                    <!--                      <td class="py-1">-->
                    <!--                        <p class="card-text text-nowrap">{{ gatewayDetails.endpoint }}</p>-->
                    <!--                      </td>-->


                    <!--                    </tr>-->
                    <!--                    <tr>-->
                    <!--                      <td colspan="4" class="hiddenRow " v-if="accordionToShow == 'a1'">-->
                    <!--                        <div class="collapse" id="demoa1">-->
                    <!--                          <div class="card-body invoice-padding pt-0" >-->
                    <!--                            <div class="row invoice-spacing">-->
                    <!--                              <div class="col-xl-12 p-0">-->
                    <!--                                <h6 class="mb-2">Request Details</h6>-->
                    <!--&lt;!&ndash;                                <pre style="overflow-x: scroll;width: 60%;">{{ gatewayDetails.request }}</pre>&ndash;&gt;-->
                    <!--                                <pre >{{gatewayDetails.request}}</pre>-->
                    <!--                              </div>-->
                    <!--                            </div>-->
                    <!--                          </div>-->

                    <!--                        </div>-->
                    <!--                        <div class="collapse" id="demoaba1">-->
                    <!--                          <div class="card-body invoice-padding pt-0" >-->
                    <!--                            <div class="row invoice-spacing">-->
                    <!--                              <div class="col-xl-12 p-0">-->
                    <!--                                <h6 class="mb-2">Response Details</h6>-->
                    <!--                                &lt;!&ndash;                                <pre style="overflow-x: scroll;width: 60%;">{{gatewayDetails.response}}</pre>&ndash;&gt;-->
                    <!--                                <pre>{{ gatewayDetails.response }}</pre>-->
                    <!--                              </div>-->
                    <!--                            </div>-->
                    <!--                          </div>-->

                    <!--                        </div>-->
                    <!--                      </td>-->
                    <!--                    </tr>-->
                    <template v-for="(item,index) in gatewayDetails">
                      <tr>
                        <td class="d-flex">
                          <button type="button" class="btn btn-sm  btn-primary waves-effect waves-float waves-light"
                                  data-toggle="collapse" :data-target="'#demo'+index"
                                  @click="accordionToShow  = index;showRequest = true">
                            Request
                          </button>
                          <button type="button"
                                  class="btn btn-sm ml-1 btn-warning  waves-effect waves-float waves-light"
                                  data-toggle="collapse" :data-target="'#demoab'+index"
                                  @click="accordionToShow  = index;showRequest = false">
                            Response
                          </button>
                        </td>
                        <td class="py-1">{{ index + 1 }}</td>
                        <td class="py-1">
                          <span class="badge badge-light-dark badge-sm" v-if="item.endpoint && getLastPart(item.endpoint) == 'reversals'">Soft Declined Reversal</span>
                          <span class="badge badge-light-dark badge-sm" v-else-if="item.endpoint && item.endpoint.indexOf('tss/v2/transactions') !== -1">Checking Transmitted Status</span>
                          <span class="badge badge-light-danger badge-sm" v-else-if="item.status == 0">Failure</span>
                          <span class="badge badge-light-success badge-sm" v-else-if="item.status == 1">Success</span>
                          <span class="badge badge-light-warning badge-sm" v-else-if="item.status == 2">Pending From Gateway</span>
                          <span class="badge badge-light-primary badge-sm" v-else-if="(item.status == 5)">3DS 2.O Device Collection Completed</span>
                          <span class="badge badge-light-dark badge-sm" v-else-if="(item.status == 7)">Manual call</span>
                          <span class="badge badge-light-info badge-sm" v-else>Gateway Response Received</span>
                        </td>
                        <td class="py-1">
                          <p class="card-text text-nowrap">{{ item.endpoint }}</p>
                        </td>
                        <td class="py-1">
                          <p class="card-text text-nowrap">{{
                              customFormatDateTime(item.created_at)
                            }}</p>
                        </td>


                      </tr>
                      <tr>
                        <td colspan="4" class="hiddenRow " v-if="accordionToShow == index">
                          <div class="collapse" :id="'demo'+index">
                            <div class="card-body invoice-padding pt-0">
                              <div class="row invoice-spacing">
                                <div class="col-xl-12 p-0">
                                  <h4 class="mb-2">Request Details</h4>
                                  <!--                                <pre style="overflow-x: scroll;width: 20%;">{{item.request}}</pre>-->
<!--                                  <pre><code v-html="syntaxHighlight(item.request)"></code></pre>-->
                                  <vue-json-pretty :path="'res'" :data="item.request" :showDoubleQuotes="false"> </vue-json-pretty>
                                  <!--                                  <template v-if="objectArrayValidate(parseJson(item.request))">-->
                                  <!--                                    <template v-for="(requestValue,requestKey) in item.request">-->
                                  <!--                                      <p class="text-primary"><strong>{{ requestKey }}</strong></p>-->
                                  <!--                                      <template v-if="objectArrayValidate(parseJson(requestValue))">-->
                                  <!--                                        <template v-for="(valueInnerValue,valueInnerKey) in parseJson(requestValue)" >-->
                                  <!--                                          <p class="text-dark" style="padding-left: 40px;" v-if="!Number.isInteger(valueInnerKey)"><strong>{{ valueInnerKey }}</strong></p>-->
                                  <!--                                          <p class="text-success" style="padding-left: 80px;">{{ valueInnerValue }}</p>-->
                                  <!--                                        </template>-->
                                  <!--                                        <hr>-->
                                  <!--                                      </template>-->
                                  <!--                                      <p v-else  class="text-success" style="padding-left: 40px;">{{ requestValue}}</p>-->
                                  <!--                                    </template>-->
                                  <!--                                  </template>-->
                                  <!--                                  <p class="text-primary" v-else><strong>{{ item.request }}</strong></p>-->


                                </div>
                              </div>
                            </div>


                          </div>
                          <div class="collapse" :id="'demoab'+index">
                            <div class="card-body invoice-padding pt-0">
                              <div class="row invoice-spacing">
                                <div class="col-xl-12 p-0">
                                  <h4 class="mb-2">Response Details</h4>
                                  <!--                                <pre style="overflow-x: scroll;width: 20%;">{{item.response}}</pre>-->
<!--                                  <pre v-html="syntaxHighlight(item.response)"></pre>-->

                                    <vue-json-pretty :path="'res'" :data="stripTags(item.response)" :showDoubleQuotes="false"> </vue-json-pretty>

<!--                                                                    <template v-if="objectArrayValidate(parseJson(item.response))">-->
<!--                                                                      <template v-for="(responseValue,responseKey) in item.response">-->
<!--                                                                        <p class="text-primary"><strong>{{ responseKey }}</strong></p>-->
<!--                                                                        <template v-if="objectArrayValidate(parseJson(responseValue))">-->
<!--                                                                          <template v-for="(valueInnerValue,valueInnerKey) in parseJson(responseValue)" >-->
<!--                                                                            <p class="text-dark" style="padding-left: 40px;" v-if="!Number.isInteger(valueInnerKey)"><strong>{{ valueInnerKey }}</strong></p>-->
<!--                                                                            <p class="text-success" style="padding-left: 80px;">{{ valueInnerValue }}</p>-->
<!--                                                                          </template>-->
<!--                                                                          <hr>-->
<!--                                                                        </template>-->
<!--                                                                        <p v-else  class="text-success" style="padding-left: 40px;">{{ responseValue}}</p>-->
<!--                                                                      </template>-->
<!--                                                                    </template>-->
<!--                                                                    <p class="text-primary" v-else><strong>{{ item.response }}</strong></p>-->
                                </div>
                              </div>
                            </div>

                          </div>
                        </td>
                      </tr>
                    </template>
                    </tbody>
                  </table>
                </div>
                <div class="col-12 d-flex mb-1  justify-content-center" v-if="loader">
                <div class="spinner-border text-primary"></div>
              </div>


              </div>
            </div>
            <!-- /Invoice -->

          </div>
        </section>


      </div>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
export default {
  components: {
    VueJsonPretty,
  },
  props: ['rowData'],
  mounted() {
    this.transactionDetails = this.rowData
    this.getGatewayDetails()
  },
  data() {
    return {
      transactionDetails: [],
      gatewayDetails: null,
      accordionToShow: -1,
      showRequest: true,
      loader:false

    }
  },
  methods: {
    getLastPart(url) {
      var parts = url.split("/");
      return (url.lastIndexOf('/') !== url.length - 1
          ? parts[parts.length - 1]
          : parts[parts.length - 2]);
    },
    syntaxHighlight(json) {
      json = JSON.stringify(json, undefined, 4);
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      json = json.replace(/^"(.+(?="$))"$/, '$1');
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return match
        return '<span class="' + cls + '">' + match + '</span>';
        // return '<span class="' + cls + '">' + match.replace(/['"]+/g, '') + '</span>';
      });
    },
    objectArrayValidate(item) {

      if (item.constructor.name == "Array" || item.constructor.name == "Object") {

        return true
      }
      return false

    },
    parseJson(str) {
      if (this.isJson(str)) {
        let temp = JSON.parse(str)
        return temp
      } else {
        return str
      }
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    getGatewayDetails() {
      this.loader = true
      let data = {
        transactionId: this.transactionDetails.uuid
        // transactionId: 'GAT_9383F25B-1128-45C1-A1ED-3E9370A8DB3A'
      }
      this.makeRequest("post", "v1/get-transaction-gateway-details", data, {}, false).then(
        (callResponse) => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            let responseData = callResponse.response.data.data;
            if (code == 200) {
              this.gatewayDetails = responseData
            }
          }
          this.loader = false
        }
      );
    }
  },
  watch: {
    rowData(val) {
      this.transactionDetails = val
      this.getGatewayDetails()
    }
  }

}
</script>
<style>
.table-scroll-y {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; background: url(https://cdn.ourcodeworld.com/assets-v2/img/code-pattern.png) #000; }
.string {
  color: #a8ff60;
  font-family: Inconsolata,Monaco,Consolas,courier new,Courier,monospace;
  direction: ltr;
  text-align: left;
  font-size: 1.1em;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: non
}
.number { color: darkorange; }
.boolean { color: blue; }
.null { color: magenta; }
.key {
  color: #c5c8c6;
  font-family: cursive;
  direction: ltr;
  text-align: left;
  font-size: 1.2em;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;

}
</style>

